import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { options, result, routes } from 'components/context/api'
import fetch from 'fetch'

const operator = process.env.REACT_APP_OPERATOR

const VippsLogin = ({ setError }) => {
  const [loading, setLoading] = useState(false)

  const handleClick = () => {
    setLoading(true)
    const opts = options({
      method: 'POST',
      body: {
        operator_id: operator,
        redirect_uri: `${window.location.origin}/vipps/callback`,
      },
    })

    fetch(routes.vippsInitiate, opts)
      .then(res => result(res))
      .then(data => {
        window.location.href = data.authorization_url
      })
      .catch(err => {
        setLoading(false)
        setError(err)
      })
  }

  return (
    <vipps-mobilepay-button
      type="button"
      brand="vipps"
      language="no"
      variant="primary"
      rounded="true"
      verb="login"
      stretched="true"
      branded="true"
      loading={loading ? 'true' : 'false'}
      onClick={handleClick}
    />
  )
}

VippsLogin.propTypes = {
  setError: PropTypes.func.isRequired,
}

export default VippsLogin
